<script setup lang="ts">
import { computed } from 'vue'

import { EngineSelector, useSelectedEngine } from '@/features/engines'

// With no engine on the course there is nothing to choose, so the bar goes. While the list
// loads, and when it fails, the bar stays to show the loader or the error.
const { hasEngines, isPending, isError } = useSelectedEngine()
const shown = computed(() => hasEngines.value || isPending.value || isError.value)
</script>

<template>
  <div
    v-if="shown"
    class="flex min-h-12 shrink-0 items-center border-b border-line bg-subbar px-6 py-2"
    data-testid="engine-bar"
  >
    <EngineSelector />
  </div>
</template>
